import { OrderExpiryTypeEnum } from '@eih-netbroker/api-order';

export const ExpiryType = OrderExpiryTypeEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ExpiryType = (typeof ExpiryType)[keyof typeof ExpiryType];
